module.exports = "/images/arrow-down-blue-icon.svg?19f0c6d40ebdff3cbd4843cf910892c2";